import * as tConst from "../Common/Constants";
import { Ticket } from "../services/Ticket";



export function pickColorAdo(item: Ticket, dimColor: boolean, isChildFromOtherProject: boolean = false): string {


  const status: string = item.state
  const planningStatus: string = item.planningStatus ? item.planningStatus : tConst.PLANNING_STATUS_NOT_STARTED;

  let baseColor: string;

  if (dimColor) {
    baseColor = tConst.COLOR_DIM;
  } else if (item.Color && item.Color !== "") {
    baseColor = item.Color;
  } else if (status === "Resolved" || status === "Closed" || status === "Done") {
    if (planningStatus === tConst.PLANNING_STATUS_NA) {
      baseColor = tConst.COLOR_DONE_NA;
    } else {
      baseColor = tConst.COLOR_DONE;
    }
  } else if (status === "Removed") {
    if (planningStatus === tConst.PLANNING_STATUS_NA) {
      baseColor = tConst.COLOR_DONE_NA;
    } else {
      baseColor = tConst.COLOR_REMOVED;
    }
  /* Må avvente hvordan vi introduserer QA i flyten for DevOps 
  } else if (status === "QA" || status === "QA WIP") {
    if (planningStatus === tConst.PLANNING_STATUS_NA) {
      baseColor = tConst.COLOR_DONE_NA;
    } else {
      baseColor = tConst.COLOR_DONE_QA;
    }
  */
  } else if (planningStatus === tConst.PLANNING_STATUS_FUNCSPEC_COMPLETE || planningStatus === tConst.PLANNING_STATUS_DEVPLAN_IN_PROGRESS) {
    baseColor = tConst.COLOR_PLANNING;
  } else if (planningStatus === tConst.PLANNING_STATUS_NOT_STARTED || planningStatus === tConst.PLANNING_STATUS_FUNCSPEC_IN_PROGRESS) {
    baseColor = tConst.COLOR_SPECING;
  } else if (planningStatus === tConst.PLANNING_STATUS_READY_FOR_CODING) {
    baseColor = tConst.COLOR_READY4CODING;
  } else if (planningStatus === tConst.PLANNING_STATUS_NA) {
    baseColor = tConst.COLOR_NA;
  } else if (planningStatus === "") {
    baseColor = tConst.COLOR_SPECING;
  } else {
    baseColor = tConst.COLOR_UNKNOWN;
  }

  // Lighten the color for children from other projects to visually distinguish them
  if (isChildFromOtherProject && !dimColor) {
    baseColor = lightenColor(baseColor, 0.4);
  }

  return baseColor;
}

/**
 * Lightens a hex color by a given amount (0 = no change, 1 = white).
 */
function lightenColor(hex: string, amount: number): string {
  // Validate hex color string: must be #RRGGBB or #RGB
  const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  if (!hexColorRegex.test(hex)) {
    // Invalid hex, return white as fallback
    return "#ffffff";
  }
  // Expand #RGB to #RRGGBB
  let normalizedHex = hex;
  if (hex.length === 4) {
    normalizedHex = "#" + hex.slice(1).split("").map(c => c + c).join("");
  }
  const num = parseInt(normalizedHex.replace("#", ""), 16);
  const r = Math.min(255, Math.round(((num >> 16) & 0xff) + (255 - ((num >> 16) & 0xff)) * amount));
  const g = Math.min(255, Math.round(((num >> 8) & 0xff) + (255 - ((num >> 8) & 0xff)) * amount));
  const b = Math.min(255, Math.round((num & 0xff) + (255 - (num & 0xff)) * amount));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}


